/* eslint-disable no-unused-vars */
import React from 'react';
import List from '@mui/material/List';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import LibraryMusicRoundedIcon from '@mui/icons-material/LibraryMusicRounded';
// import PlaylistAddCheckRoundedIcon from '@material-ui/icons/PlaylistAddCheckRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RateReviewIcon from '@mui/icons-material/RateReview';
// import { useRouter } from 'next/router';
import { AutoGraph, Chat } from '@mui/icons-material';
import { Badge } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import { useSpaces } from '@app/contexts/SpacesContext';
import { useUser } from '@app/helpers/hooks';
import SidebarItem from './SidebarItem';
import { useTranslation } from '../../../../config/i18n';

// const { getRouteName } = require('../../../../server/routes');

var Lists = function Lists(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(List, null, children);
};
Lists.defaultProps = {
  children: /*#__PURE__*/React.createElement(React.Fragment)
};
export var organisationList = function organisationList() {
  var _useTranslation = useTranslation('common'),
    t = _useTranslation.t;

  // const activeRouteName = routes.map

  return /*#__PURE__*/React.createElement(List, {
    style: {
      padding: '0'
    }
  }, /*#__PURE__*/React.createElement(SidebarItem, {
    text: t('my_opps'),
    icon: /*#__PURE__*/React.createElement(DashboardRoundedIcon),
    link: 'my_opportunities'
  }), /*#__PURE__*/React.createElement(SidebarItem, {
    text: t('organisation_plural'),
    icon: /*#__PURE__*/React.createElement(BusinessRoundedIcon),
    link: 'my_organisations'
  }), /*#__PURE__*/React.createElement(SidebarItem, {
    text: t('Impact'),
    icon: /*#__PURE__*/React.createElement(AutoGraph),
    link: 'insight_dashboard'
  }));
};
export var GeneralList = function GeneralList(_ref2) {
  var role = _ref2.role,
    hasReviews = _ref2.hasReviews;
  var _useTranslation2 = useTranslation('common'),
    t = _useTranslation2.t;
  var _ref3 = useSpaces() || {},
    _ref3$globalUnreadCou = _ref3.globalUnreadCount,
    globalUnreadCount = _ref3$globalUnreadCou === void 0 ? 0 : _ref3$globalUnreadCou;
  var _ref4 = useUser() || {},
    user = _ref4.user;
  var isProduction = process.env.NEXT_PUBLIC_ENV === 'production';
  var allowedEmails = ['jmi@mubazar.com', 'matt@jmi.net', 'siri@jmn.no'];
  return /*#__PURE__*/React.createElement(List, {
    style: {
      padding: '0'
    }
  }, /*#__PURE__*/React.createElement(SidebarItem, {
    text: t('explore_opportunities'),
    icon: /*#__PURE__*/React.createElement(LibraryMusicRoundedIcon),
    link: 'opportunity_search'
  }), /*#__PURE__*/React.createElement(SidebarItem, {
    text: t('my_applications'),
    icon: /*#__PURE__*/React.createElement(AssignmentIcon),
    link: 'my_applications'
  }), !isProduction || allowedEmails.includes(user === null || user === void 0 ? void 0 : user.email) || isProduction && user !== null && user !== void 0 && user.has_spaces ? /*#__PURE__*/React.createElement(SidebarItem, {
    text: t('spaces'),
    icon: /*#__PURE__*/React.createElement(Badge, {
      badgeContent: globalUnreadCount,
      color: 'error'
    }, /*#__PURE__*/React.createElement(GroupsIcon, null, /*#__PURE__*/React.createElement(Chat))),
    link: 'spaces'
  }) : null, hasReviews ? /*#__PURE__*/React.createElement(SidebarItem, {
    text: 'Reviewing',
    icon: /*#__PURE__*/React.createElement(RateReviewIcon),
    link: 'review_opportunities'
  }) : null);
};
GeneralList.defaultProps = {
  hasReviews: false
};
Lists.organisationList = organisationList;
Lists.GeneralList = GeneralList;
export default Lists;